import {
  BookingIssue,
  BookingPaymentBalanceStatus,
  BookingStatus,
} from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { createRandomClassName } from '@new/domains/fastBookingsTapeChart/__utils'

import { cssVar } from '@utils/cssVar'

export const firstColumnWidthVar = cssVar('first-column-width')
export const visibleDatesCountVar = cssVar('visible-dates-count')
export const borderColorVar = cssVar('border-color')
export const dateCellWidthVar = cssVar('date-cell-width')
export const foregroundVar = cssVar('foreground')
export const foregroundBorderVar = cssVar('foreground-border')
export const backgroundVar = cssVar('background')
export const hoverShadowVar = cssVar('hover-shadow')
export const highlightingBackgroundVar = cssVar('highlighting-background')
export const occupiedPeriodCursorVar = cssVar('cursor')
export const propertyRowHeightVar = cssVar('property-row-height')
export const tapeOpacityVar = cssVar('tape-opacity')

export enum zIndex {
  zero,
  headerRowAvailableDatesIndicator,
  tapes,
  selectedRange,
  prev7DaysButtonMobile,
  homeInfoCell,
  regionRow,
  headerRow,
  searchCell,
  prev7DaysButton,
  bottomBar,
}

export const sharedClassNames = {
  dateInfoCellValue: createRandomClassName(),
  occupiedPeriodWithVisibleRates: createRandomClassName(),
  bookingPeriod: createRandomClassName(),
}

export enum ClassNamePrefixes {
  ReservationStatus = 'reservationStatus-',
  PaymentStatus = 'paymentStatus-',
  DepositOnHold = 'depositOnHold',
  Issue = 'issue-',
  HighlightedTape = 'highlightedTape',
}

export const getPaymentStatusClassname = (status: BookingPaymentBalanceStatus) =>
  `${ClassNamePrefixes.PaymentStatus}${status}`

export const getReservationStatusClassname = (status: BookingStatus) =>
  `${ClassNamePrefixes.ReservationStatus}${status}`

export const getDepositOnHoldClassname = (securityDepositStatus: boolean) => {
  if (securityDepositStatus !== false) {
    return undefined
  }
  // Security Deposit rules by status:
  // false = we have it.
  // true = we have returned it
  // null = never captured it
  return ClassNamePrefixes.DepositOnHold
}

export const getIssueClassname = (issue: BookingIssue) => `${ClassNamePrefixes.Issue}${issue}`

export const getHighlightedClassname = (highLighted?: boolean) =>
  `${ClassNamePrefixes.HighlightedTape}-${highLighted}`
